module.exports = __webpack_public_path__ + "e160c65bf9451b4f0566c607c1e325b0.png";